import { AspectRatio, GcsImage } from "@zickko/shared";
import { ValidationResult } from "nutso";
import { DynamicImage } from "../elements/DynamicImage";
import { FileInput } from "../elements/FileInput";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = FormItemProps<GcsImage> & {
  value?: GcsImage;
  aspectRatio: AspectRatio;
  gcsBucket: string;
  gcsFolder: string;
  onChange: (value: GcsImage) => void;
  validation?: ValidationResult;
  dataCy?: string;
  onClear?: () => void;
};

export const FormImageUpload = (props: Props) => {
  //
  const renderPreview = () => {
    const { value: image } = props;
    if (!image || !image.path) return null;
    return (
      <div className="image-preview">
        <DynamicImage image={image} aspectRatio={props.aspectRatio} />
      </div>
    );
  };

  const { gcsBucket, gcsFolder, onChange, value: image, dataCy, onClear } = props;
  const fileExtensions = ["jpg", "jpeg", "png", "gif", "JPG", "JPEG", "PNG", "GIF"];

  return (
    <FormItemContainer<GcsImage> {...props} additionalClassNames={`form-image-upload ${props.additionalClassNames}`}>
      {renderPreview()}
      <FileInput
        allowedFiles={fileExtensions}
        gcsFolder={gcsFolder}
        gcsBucket={gcsBucket}
        onUploadComplete={(fileInfo) => onChange(fileInfo)}
        dataCy={dataCy}
      />
      {onClear && image && (
        <a className="clear-link" onClick={onClear}>
          Remove
        </a>
      )}
    </FormItemContainer>
  );
};
